import TaglineBlock from "./TaglineBlock";

export default TaglineBlock;
